import { CreateShiftCommand, ShiftsApi, UpdateShiftCommand } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class ShiftService {
  httpClient = createApiClient(ShiftsApi)

  async load() {
    const { data } = await createApiClient(ShiftsApi).get()
    return data
  }

  async update(updateShiftCommand: UpdateShiftCommand) {
    const { data } = await createApiClient(ShiftsApi).update(updateShiftCommand)
    return data
  }

  async create(createShiftCommand: CreateShiftCommand) {
    const { data } = await createApiClient(ShiftsApi).create(createShiftCommand)
    return data
  }

  async delete(ids: number[]) {
    const { data } = await createApiClient(ShiftsApi)._delete(ids)
    return data
  }
}

const shiftService = new ShiftService()

export default shiftService
